<template>
  <el-row class="text-align-left">
    <el-col :span="24">
      <Header></Header>
      <el-col :xl="22" :lg="22" :offset="1" class="page-title">Regional Account Maintenance</el-col>
      <el-col :xl="3" :lg="4" :offset="1" class="margin-top">
        <el-form label-position="top" :model="regionAccountSearchInfo" ref="searchForm">
          <el-form-item label="Company">
            <el-select v-model="regionAccountSearchInfo.company" placeholder="PLEASE SELECT" >
              <el-option
                v-for="(item,index) in companyListSearch"
                :key="index"
                :label="item.companyName"
                :value="item.companyValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Region/HQ department">
            <el-select v-model="regionAccountSearchInfo.region" placeholder="PLEASE SELECT">
              <el-option
                v-for="(item,index) in regionListSearch"
                :key="index"
                :label="item.regionName"
                :value="item.regionValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Name">
            <el-autocomplete popper-class="my-autocomplete" v-model="regionAccountSearchInfo.name" :fetch-suggestions="querySearch">
              <template slot-scope="{ item }">
                <div class="name">{{ item.value}}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item prop="email" label="Email"
                        :rules="[{ type: 'email', message: incorrectEmailMsg, trigger: ['blur', 'change'] }]">
            <el-input v-model="regionAccountSearchInfo.email" onKeypress="if(event.keyCode == 32) event.returnValue = false"></el-input>
          </el-form-item>
          <el-form-item label="Status">
            <el-select v-model="regionAccountSearchInfo.active" placeholder="PLEASE SELECT">
              <el-option
                v-for="(item,index) in activeObjects"
                :key="index"
                :label="index"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button type="danger" class="search-btn" @click="searchValidateAndCall">Search</el-button>
      </el-col>
      <el-col :xl="1" :lg="1" class="margin-top">
        <div class="line"></div>
      </el-col>
      <el-col :xl="18" :lg="17" class="margin-top">
        <el-button @click="showAddDialog">Add</el-button>
        <el-button @click="showModifyDialog">Modify</el-button>
        <el-button @click="uploadDialogVisible = true">Upload</el-button>
        <el-button @click="exportTableData">Export</el-button>
        <!--<el-button @click="exportTableData">Export</el-button>-->
        <el-table class="vendor-table" empty-text="No Data" :data="regionAccountSearchInfoList"
                  ref="multipleTable" stripe @row-dblclick="handleRowDBClick" max-height="700"
                  style="width: 100%" highlight-current-row @selection-change="handleSelectionChange" :default-sort = "{prop: 'id', order: 'ascending'}"
                  v-loading="loadingStatus">
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="Company" sortable prop="company" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.company}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Region/HQ department" sortable prop="region" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.region}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Name" sortable prop="name" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Email" sortable prop="email" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.email}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Active" sortable prop="active" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.active=='1'">Active</span>
              <span v-if="scope.row.active=='0'">Inactive</span>
            </template>
          </el-table-column>
          <el-table-column label="Last Updated By" sortable prop="modifiedBy" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.modifiedBy}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Last Updated Date" sortable prop="modifiedDate" width="190">
            <template slot-scope="scope">
              <span v-if="scope.row.newModifiedDate != null">{{scope.row.newModifiedDate}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="table-nav" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" background
                       :page-sizes="[20,40, 100, 200, 500]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close='closeDialog' width="500px" top="100px">
          <el-form label-position="top" :model="updateRegionAccountInfo" :rules="rules" class="dialog-form" ref="updateForm">
            <el-form-item label="Company" prop="company">
              <el-input v-model="updateRegionAccountInfo.company" :disabled="dialogTitle!='Add Region Account'"></el-input>
            </el-form-item>
            <el-form-item label="Region/HQ department" prop="region">
              <el-input v-model="updateRegionAccountInfo.region"></el-input>
            </el-form-item>
            <el-form-item label="Name" prop="name" >
              <el-autocomplete popper-class="my-autocomplete" v-model="updateRegionAccountInfo.name" :fetch-suggestions="querySearch">
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value}}</div>
                </template>
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="Active" prop="active" v-if="dialogTitle!='Add Region Account'">
              <el-select v-model="updateRegionAccountInfo.active">
                <el-option v-for="item in activeStatus" :key="item.key" :label="item.label" :value="item.value" :disabled="item.disable"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleCancelBtn">Cancel</el-button>
            <el-button type="danger" @click="handleSaveRegionAccount">Save</el-button>
          </span>
        </el-dialog>
        <el-dialog title="Upload Regional Account" :visible.sync="uploadDialogVisible" width="30%" center>
          <el-upload
            class="upload-demo"
            ref="upload"
            :action="regionalVendorUploadUrl"
            :on-remove="handleRemove"
            :on-change="handleChange"
            :before-upload="validateFileType"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-progress="handleOnProgress"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :headers="{'Authentication-Token': jwtToken}"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="danger" plain>Select File</el-button>
            <el-button style="margin-left: 10px;" size="small"  @click="submitUpload" plain>Upload</el-button>
            <div slot="tip" class="el-upload__tip">Only Support for Excel File.</div>
          </el-upload>
        </el-dialog>
      </el-col>
    </el-col>
    <Footer></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import { findAllDataByConditions, findSearchConditions, findRegionAccountByConditions, saveRegionAccountInfo, findAllActiveDisplayNames } from '@/services/regionAccount.service';
import Constant from '@/common/Constant';
import CookiesHelper from '@/utils/cookiesHelper';
import getBaseUrl from '@/utils/apiBaseUrlHelper';
import CommonHelper from '@/utils/commonHelper';

export default {
  components: {
    Footer,
    Header
  },
  data () {
    var checkName = (rule, value, callback) => {
      let m = 0;
      for (let i = 0; i < this.displayNames.length; i++) {
        if (this.displayNames[i].value === this.updateRegionAccountInfo.name) {
          m++;
        }
      }
      if (m === 0) {
        callback(new Error(Constant.INPUT_CORRECT_NAME));
      } else {
        callback();
      }
    };
    return {
      fileList: [],
      regionAccountSearchInfoList: [],
      regionList: [],
      companyList: [],
      regionListSearch: [],
      companyListSearch: [],
      activeObjects: {},
      regionAccountSearchInfo: {
        pageSize: 20,
        currentPage: 1,
        company: '',
        region: '',
        email: '',
        name: '',
        active: '',
        esgStaffInfo: [{displayName: ''}]
      },
      exportConditions: {
        company: '',
        region: '',
        email: '',
        name: '',
        active: ''
      },
      displayNames: [],
      state: '',
      dialogVisible: false,
      uploadDialogVisible: false,
      incorrectEmailMsg: Constant.ENTER_CORRECT_EMAIL,
      regionalVendorUploadUrl: `${getBaseUrl()}/esg/security/vendorRegionalAccounts/upload`,
      multipleSelection: [],
      updateRegionAccountInfo: {
        id: '',
        company: '',
        region: '',
        email: '',
        name: '',
        active: '',
        esgStaffInfo: [{displayName: ''}]
      },
      dialogTitle: '',
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      loadingStatus: false,
      activeStatus: [
        {
          key: 'Active',
          value: '1',
          label: 'Active',
          disable: false
        },
        {
          key: 'Inactive',
          value: '0',
          label: 'Inactive',
          disable: false
        }
      ],
      rules: {
        email: [
          { required: true, message: Constant.INPUT_EMAIL, trigger: 'blur' },
          { type: 'email', message: Constant.ENTER_CORRECT_EMAIL, trigger: ['blur', 'change'] }
        ],
        region: [
          { required: true, message: Constant.INPUT_REGION, trigger: ['blur', 'change'] }
        ],
        company: [
          { required: true, message: Constant.INPUT_COMPANY, trigger: ['blur', 'change'] }
        ],
        name: [
          { required: true, message: Constant.INPUT_NAME, trigger: ['blur', 'change'] },
          { validator: checkName, trigger: 'blur' }
        ]
      },
      jwtToken: CookiesHelper.get('JWT-TOKEN-HEADER')
    }
  },
  methods: {
    async exportTableData () {
      this.$loading({fullscreen: true});
      let vendorRegionalAccounts = await findAllDataByConditions(this.exportConditions);
      require.ensure([], () => {
        const { exportJsonToExcel } = require('@/utils/Export2Excel');
        let tHeader = ['ID', 'Company', 'Region', 'Name', 'Email', 'Active', 'Last Updated By', 'Last UpadtedDate'];
        let filterVal = ['id', 'company', 'region', 'name', 'email', 'active', 'modifiedBy', 'modifiedDate'];
        let exportRegionalAccountList = JSON.parse(JSON.stringify(vendorRegionalAccounts.data));
        exportRegionalAccountList.forEach(item => {
          item.active = item.active === '1' ? 'YES' : 'NO';
          item.modifiedDate = CommonHelper.formatDate(item.modifiedDate);
        });
        let data = this.formatJson(filterVal, exportRegionalAccountList);
        exportJsonToExcel(tHeader, data, 'RegionalAccountList');
      });
      this.$loading({fullscreen: true}).close();
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    async regionAccountInfo () {
      this.$loading({fullscreen: true});
      let searchConditions = await findSearchConditions();
      this.initSearchForm(searchConditions.data);
      this.$loading({fullscreen: true}).close();
    },
    initPageData (responseData) {
      this.regionAccountSearchInfoList = [];
      responseData.forEach(item => {
        item.newModifiedDate = CommonHelper.formatDate(item.modifiedDate);
        item.name = item.esgStaffInfo.displayName;
        item.email = item.esgStaffInfo.email;
        this.regionAccountSearchInfoList.push(item);
      });
    },
    initSearchForm (data) {
      this.companyListSearch = [];
      this.regionListSearch = [];
      this.activeObjects = {};
      let regionSet = new Set();
      let companySet = new Set();
      data.regions.forEach(item => {
        if (item !== '' && item !== null) {
          regionSet.add(item);
        }
      });
      data.companies.forEach(item => {
        if (item !== '' && item !== null) {
          companySet.add(item);
        }
      });
      // region dropdown
      let tempRegionObjects = {};
      regionSet.forEach(it => {
        tempRegionObjects[it] = it;
      });
      let regionForAll = {
        regionValue: '',
        regionName: '<ALL>'
      };
      this.regionListSearch.push(regionForAll);
      Object.keys(tempRegionObjects).sort().forEach(item => {
        let region = {
          regionValue: item,
          regionName: item
        };
        this.regionListSearch.push(region);
      });
      // company dropdown
      let tempCompanyObjects = {};
      companySet.forEach(it => {
        tempCompanyObjects[it] = it;
      });
      let companyForAll = {
        companyValue: '',
        companyName: '<ALL>'
      };
      this.companyListSearch.push(companyForAll);
      Object.keys(tempCompanyObjects).sort().forEach(item => {
        let company = {
          companyValue: item,
          companyName: item
        };
        this.companyListSearch.push(company);
      });
      // status dropdown
      this.activeObjects['<ALL>'] = '';
      this.activeObjects['Active'] = '1';
      this.activeObjects['Inactive'] = '0';
      this.regionAccountSearchInfo = {
        pageSize: 20,
        currentPage: 1,
        company: '',
        region: '',
        email: '',
        name: '',
        active: ''
      };
      this.exportConditions =
        {
          company: '',
          region: '',
          email: '',
          name: '',
          active: ''
        };
    },
    handleSaveRegionAccount () {
      this.$refs.updateForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.saveRegionAccountInfo();
        }
      });
    },
    async saveRegionAccountInfo () {
      this.$loading({fullscreen: true});
      if (!this.updateRegionAccountInfo.active) {
        this.updateRegionAccountInfo.active = '1';
      }
      this.updateRegionAccountInfo.company = this.updateRegionAccountInfo.company.trim();
      this.updateRegionAccountInfo.region = this.updateRegionAccountInfo.region.trim();
      let responseData = await saveRegionAccountInfo(this.updateRegionAccountInfo);
      if (responseData.code === Constant.RESPONSE_SUCCESS_CODE) {
        this.regionAccountSearchInfoList = [];
        this.pageSize = 20;
        this.currentPage = 1;
        this.regionAccountSearchInfo = {
          pageSize: 20,
          currentPage: 1,
          company: '',
          region: '',
          email: '',
          name: '',
          active: ''
        };
        this.exportConditions =
          {
            company: '',
            region: '',
            email: '',
            name: '',
            active: ''
          };
        sessionStorage.setItem(Constant.REGION_ACCOUNT_SEARCH_CONDITIONS, JSON.stringify(this.regionAccountSearchInfo));
        this.searchInfo();
        this.regionAccountInfo();
        this.$message.success(Constant.SAVE_SUCCEED);
      }
      this.dialogVisible = false;
      this.updateRegionAccountInfo = {esgStaffInfo: ''};
      this.$loading({fullscreen: true}).close();
    },
    // get the user selected's data
    handleSelectionChange (value) {
      this.multipleSelection = value;
    },
    handleRowDBClick (row, event) {
      this.dialogTitle = 'Modify Region Account';
      row.name = row.esgStaffInfo.displayName;
      this.updateRegionAccountInfo = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    showAddDialog () {
      this.dialogTitle = 'Add Region Account';
      this.dialogVisible = true;
      this.updateRegionAccountInfo = {esgStaffInfo: [{displyName: ''}]};
    },
    showModifyDialog () {
      if (this.multipleSelection.length === 1) {
        this.dialogTitle = 'Modify Region Account';
        this.multipleSelection[0].name = this.multipleSelection[0].esgStaffInfo.displayName;
        this.updateRegionAccountInfo = JSON.parse(JSON.stringify(this.multipleSelection[0]));
        this.dialogVisible = true;
      } else {
        if (this.multipleSelection.length === 0) {
          this.$message.warning(Constant.SELECT_NONE_LINE);
        } else {
          this.$message.warning(Constant.SELECT_MULTIPLE_LINES);
        }
      }
    },
    handleCancelBtn () {
      this.dialogVisible = false;
      this.$refs.updateForm.resetFields();
    },
    searchValidateAndCall () {
      Object.assign(this.exportConditions, this.regionAccountSearchInfo);
      this.pageSize = 20;
      this.currentPage = 1;
      this.regionAccountSearchInfo.pageSize = 20;
      this.regionAccountSearchInfo.currentPage = 1;
      this.$refs.searchForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          sessionStorage.setItem(Constant.REGION_ACCOUNT_SEARCH_CONDITIONS, JSON.stringify(this.regionAccountSearchInfo));
          this.searchInfo();
        }
      });
    },
    async searchInfo () {
      this.loadingStatus = true;
      let regionAccountSearchInfo = JSON.parse(sessionStorage.getItem(Constant.REGION_ACCOUNT_SEARCH_CONDITIONS));
      let regionAccountData = await findRegionAccountByConditions(regionAccountSearchInfo);
      this.totalCount = regionAccountData.data.totalCount;
      if (regionAccountData.data.esgVendorRegionalAccountsVos.length !== 0) {
        this.initPageData(regionAccountData.data.esgVendorRegionalAccountsVos);
      } else {
        this.regionAccountSearchInfoList = [];
      }
      this.loadingStatus = false;
    },
    handleSizeChange (val) {
      this.pageSize = val;
      this.regionAccountSearchInfo = JSON.parse(sessionStorage.getItem(Constant.REGION_ACCOUNT_SEARCH_CONDITIONS));
      this.regionAccountSearchInfo.pageSize = val;
      sessionStorage.setItem(Constant.REGION_ACCOUNT_SEARCH_CONDITIONS, JSON.stringify(this.regionAccountSearchInfo));
      this.searchInfo();
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      this.regionAccountSearchInfo = JSON.parse(sessionStorage.getItem(Constant.REGION_ACCOUNT_SEARCH_CONDITIONS));
      this.regionAccountSearchInfo.currentPage = val;
      sessionStorage.setItem(Constant.REGION_ACCOUNT_SEARCH_CONDITIONS, JSON.stringify(this.regionAccountSearchInfo));
      this.searchInfo();
    },
    // upload
    validateFileType (file) {
      const extension = file.name.split('.')[1] === 'xls';
      const extension2 = file.name.split('.')[1] === 'xlsx';
      if (!extension && !extension2) {
        this.$message.error('Only Excel File is Allowed.');
        return false;
      } else {
        return true;
      }
    },
    async submitUpload () {
      if (this.fileList.length === 0) {
        this.$alert(Constant.SUBMIT_NO_FILE, 'Warning', {
          confirmButtonText: 'OK'
        });
        return;
      } else if (this.fileList.length > 1) {
        this.$alert(Constant.SUBMIT_MULTIPLE_FILES, 'Warning', {
          confirmButtonText: 'OK'
        });
        return;
      }
      this.$refs.upload.submit();
      this.uploadDialogVisible = false;
    },
    handleRemove (file, fileList) {
      this.fileList = fileList;
    },
    handleChange (file, fileList) {
      this.fileList = fileList;
      this.$loading({fullscreen: true}).close();
    },
    handleExceed (file, fileList) {
      this.$message.warning(Constant.SELECT_MUTILPLE_FILES);
    },
    handleOnProgress (event, file, fileList) {
      this.$loading({fullscreen: true});
    },
    handleSuccess (response, file, fileList) {
      if (response.code === Constant.POPUP_EXCEPTION_CODE && response.msg !== '') {
        this.$alert(response.msg, 'Warning', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: 'OK',
          callback: action => {
            this.resetPage();
          }
        });
      } else if (response.code === Constant.RESPONSE_SYSTEMERROR_CODE) {
        this.$message.error(response.msg);
      } else {
        this.$alert('Upload success!', 'Tips', {
          confirmButtonText: 'OK'
        });
        // search regional vendor info
        this.resetPage();
      }
      this.$refs.upload.clearFiles();
    },
    handleError (response) {
      CommonHelper.handleExceptionForComponentRequest(response);
    },
    closeDialog () {
      this.dialogVisible = false;
      this.updateRegionAccountInfo = {esgStaffInfo: ''};
      this.$refs.updateForm.resetFields();
    },
    querySearch (queryString, cb) {
      var displayNames = this.displayNames;
      var results = queryString ? displayNames.filter(this.createFilter(queryString)) : displayNames;
      cb(results);
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    async loadAllDisplayNames () {
      let alldisplaynameslist = await findAllActiveDisplayNames();
      let displaynameslist = alldisplaynameslist.data.displaynames;
      var arr = []
      for (let i in displaynameslist) {
        let o = {};
        o['value'] = displaynameslist[i];
        arr.push(o);
      }
      return arr;
    },
    dateFormat (row, column) {
      return row.modifiedDate.substring(0, row.modifiedDate.lastIndexOf('.')).replace('T', ' ');
    },
    resetPage () {
      this.regionAccountSearchInfoList = [];
      this.pageSize = 20;
      this.currentPage = 1;
      this.regionAccountSearchInfo = {
        pageSize: 20,
        currentPage: 1,
        company: '',
        region: '',
        email: '',
        name: '',
        active: '',
        esgStaffInfo: [{displayName: ''}]
      };
      this.exportConditions =
        {
          company: '',
          region: '',
          email: '',
          name: '',
          active: ''
        };
      sessionStorage.setItem(Constant.REGION_ACCOUNT_SEARCH_CONDITIONS, JSON.stringify(this.regionAccountSearchInfo));
      this.searchInfo();
      this.regionAccountInfo();
    }
  },
  mounted () {
    sessionStorage.setItem(Constant.REGION_ACCOUNT_SEARCH_CONDITIONS, JSON.stringify(this.regionAccountSearchInfo));
    this.regionAccountInfo().then(value => {
      this.searchInfo();
    });
    this.loadAllDisplayNames().then(result => {
      this.displayNames = result;
    });
  },
  beforeDestroy () {
    this.$loading({fullscreen: true}).close();
  }
};
</script>

<style scoped>
  .text-align-left {
    text-align: left;
  }

  .page-title{
    font-size: 20px;
    margin-top: 80px;
  }
  .margin-top{
    margin-top: 30px;
  }
  .line {
    width: 1px;
    height: 700px;
    background-color: #e6e6e6;
    margin-left: 20px;
  }

  .vendor-table{
    margin-top: 15px;
  }

  .table-nav{
    position: fixed;
    bottom: 40px;
  }

  >>>.search-btn{
    margin-top: 20px!important;
    width: 200px;
  }

  /*rewrite element-ui */

  >>>.dialog-form .el-input{
    width: 360px;
  }

  >>>.el-dialog__footer {
    padding: 40px 70px 20px;
  }
  >>>.el-button{
    border-color: #5e89ed;
    color: #5e89ed;
  }

  >>>.el-button:hover{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button:focus{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger{
    background-color: #5e89ed;
    border-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger:hover{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-button--danger:focus{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-table{
    color: black;
  }

  >>>.el-table thead{
    color: black;
  }

  >>>.el-form--label-top .el-form-item__label{
    padding: 0;
  }

  >>>.el-form-item{
    margin-bottom: 5px;
  }

  >>>.el-pager li.active{
    color: #5e89ed;
  }

  >>>.el-pager li:hover{
    color: #5e89ed;
  }

  >>>.el-checkbox__inner{
    border: 1px solid #aaaaaa;
  }

  >>>.el-form-item__label{
    line-height: 32px;
  }

  .el-dialog__body{
    padding: 5px 70px;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #5e89ed;
    border-color: #5e89ed;
  }
</style>
<style>
  .el-input{
    margin-top: 0;
    width: 200px;
  }
  .el-dialog__body{
    padding: 5px 70px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/RegionalAccountMaintenance.vue